export default "__VITE_ASSET__GKcyk5ZK__"